__turbopack_context__.v({
  "container": "applyPage-module__Ibo2Yq__container",
  "fadeInItems": "applyPage-module__Ibo2Yq__fadeInItems",
  "section": "applyPage-module__Ibo2Yq__section",
  "sectionActive": "applyPage-module__Ibo2Yq__sectionActive",
  "sectionContent": "applyPage-module__Ibo2Yq__sectionContent",
  "sectionTitle": "applyPage-module__Ibo2Yq__sectionTitle",
  "spacing--lg": "applyPage-module__Ibo2Yq__spacing--lg",
  "spacing--md": "applyPage-module__Ibo2Yq__spacing--md",
  "spacing--sm": "applyPage-module__Ibo2Yq__spacing--sm",
  "spacing--xl": "applyPage-module__Ibo2Yq__spacing--xl",
  "spacing--xs": "applyPage-module__Ibo2Yq__spacing--xs",
  "spacing--xxl": "applyPage-module__Ibo2Yq__spacing--xxl",
  "spacing--xxs": "applyPage-module__Ibo2Yq__spacing--xxs",
  "spacing--xxxl": "applyPage-module__Ibo2Yq__spacing--xxxl",
  "spacing--xxxs": "applyPage-module__Ibo2Yq__spacing--xxxs",
  "title": "applyPage-module__Ibo2Yq__title",
});
